import React from 'react'
import './newfooter.scss'

const Newfooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
          <div className="loginfooter">
          <div className="custom-container">
            <div className="innerloginfooter">
            <img src="/logo.svg" alt="logoimg" className="logoimg" />
            <p className="footerpara">©{currentYear} GEMS. All rights reserved</p>
            </div>
          </div>
        </div>
    </>
  )
}

export default Newfooter
